"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var bulletChartSeries_1 = require("./bulletChartSeries");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var executionResultHelper_1 = require("../_util/executionResultHelper");
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var color_1 = require("../_util/color");
var BulletChartColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(BulletChartColorStrategy, _super);
    function BulletChartColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BulletChartColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    _stackByAttribute, dv) {
        var _this = this;
        var occupiedMeasureBucketsLocalIdentifiers = bulletChartSeries_1.getOccupiedMeasureBucketsLocalIdentifiers(dv);
        var measureGroup = executionResultHelper_1.findMeasureGroupInDimensions(dv.meta().dimensions());
        var defaultColorsAssignment = this.getDefaultColorAssignment(colorPalette, measureGroup, occupiedMeasureBucketsLocalIdentifiers);
        var colorAssignment = measureGroup.items.map(function (headerItem) {
            var color = _this.mapMeasureColor(headerItem, colorPalette, colorMapping, dv, defaultColorsAssignment);
            return {
                headerItem: headerItem,
                color: color,
            };
        });
        return {
            fullColorAssignment: colorAssignment,
        };
    };
    BulletChartColorStrategy.prototype.createPalette = function (colorPalette, colorAssignments) {
        return colorAssignments
            .map(function (colorAssignment, index) {
            if (sdk_model_1.isRgbColor(colorAssignment.color)) {
                return colorAssignment.color.value;
            }
            else if (sdk_model_1.isColorFromPalette(colorAssignment.color)) {
                return sdk_ui_vis_commons_1.getColorByGuid(colorPalette, colorAssignment.color.value, index);
            }
        })
            .filter(Boolean)
            .map(function (color) { return sdk_ui_vis_commons_1.getRgbStringFromRGB(color); });
    };
    BulletChartColorStrategy.prototype.mapMeasureColor = function (headerItem, colorPalette, colorMapping, dv, defaultColorsAssignment) {
        var mappedColor = sdk_ui_vis_commons_1.getColorFromMapping(headerItem, colorMapping, dv);
        if (sdk_ui_vis_commons_1.isValidMappedColor(mappedColor, colorPalette)) {
            return mappedColor;
        }
        var defaultColorAssignment = defaultColorsAssignment.find(function (colorAssignment) {
            return colorAssignment.headerItem.measureHeaderItem.localIdentifier ===
                headerItem.measureHeaderItem.localIdentifier;
        });
        return defaultColorAssignment.color;
    };
    BulletChartColorStrategy.prototype.getDefaultColorAssignment = function (colorPalette, measureGroup, occupiedMeasureBucketsLocalIdentifiers) {
        var _this = this;
        return measureGroup.items.map(function (headerItem, index) {
            var _a, _b, _c, _d, _e;
            var color = (bulletChartSeries_1.isPrimarySeries(index, occupiedMeasureBucketsLocalIdentifiers) && {
                type: "guid",
                value: colorPalette[0].guid,
            }) ||
                (bulletChartSeries_1.isTargetSeries(index, occupiedMeasureBucketsLocalIdentifiers) && {
                    type: "rgb",
                    value: sdk_ui_vis_commons_1.getLighterColorFromRGB(colorPalette[0].fill, sdk_ui_theme_provider_1.isDarkTheme(_this.theme) ? 0.5 : -0.3),
                }) ||
                (bulletChartSeries_1.isComparativeSeries(index, occupiedMeasureBucketsLocalIdentifiers) && {
                    type: "rgb",
                    value: ((_b = (_a = _this.theme) === null || _a === void 0 ? void 0 : _a.palette) === null || _b === void 0 ? void 0 : _b.complementary) ? sdk_ui_vis_commons_1.parseRGBString(sdk_ui_vis_commons_1.normalizeColorToRGB((_e = (_d = (_c = _this.theme) === null || _c === void 0 ? void 0 : _c.palette) === null || _d === void 0 ? void 0 : _d.complementary) === null || _e === void 0 ? void 0 : _e.c2))
                        : color_1.DEFAULT_BULLET_GRAY_COLOR,
                });
            return {
                headerItem: headerItem,
                color: color,
            };
        });
    };
    return BulletChartColorStrategy;
}(sdk_ui_vis_commons_1.ColorStrategy));
exports.default = BulletChartColorStrategy;
//# sourceMappingURL=bulletChartColoring.js.map